import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class ActionLink extends Component {
  static propTypes = {
    onClickHandler: PropTypes.func,
    theme: PropTypes.string,
    children: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      onClickHandler,
      children,
      theme
    } = this.props;

    return (
      <a className={`actionLink${theme ? '--' + theme : ''}`} onClick={onClickHandler}>{children}</a>
    );
  }
}
